import { useOrder, MESH_OPTIONS } from "../../context/OrderContext";
import { Check } from "lucide-react";

/**
 * "Select Your Mesh Type" upgrade step. Window screens only.
 * Single selection, default Standard. Selection applies to ALL screens.
 */
export default function StepMesh() {
  const { state, update, goNext, goBack } = useOrder();
  const qty = state.quantity || 1;
  const selected = state.meshType || "standard";

  return (
    <div data-testid="step-mesh">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2 text-[var(--brand-text)]">
        Select Your Mesh Type
      </h1>
      <p className="muted-text mb-5">
        All screens come standard with high-quality fiberglass mesh. Upgrade options are available below.
      </p>

      <div className="space-y-3">
        {MESH_OPTIONS.map((m) => {
          const isSelected = selected === m.id;
          const lineTotal = m.upcharge * qty;
          return (
            <button
              key={m.id}
              type="button"
              data-testid={`mesh-option-${m.id}`}
              onClick={() => update({ meshType: m.id })}
              className={`option-card w-full text-left ${isSelected ? "selected" : ""}`}
            >
              <div className="flex items-start gap-3">
                <div className="flex-1">
                  <div className="flex justify-between items-start gap-3">
                    <p className="font-semibold text-[var(--brand-text)]">
                      {m.name}
                      {m.upcharge > 0 && (
                        <span className="brand-text font-bold ml-1">
                          (+${m.upcharge} per screen)
                        </span>
                      )}
                    </p>
                    {isSelected && <Check className="w-5 h-5 brand-text shrink-0" />}
                  </div>
                  <p className="text-sm muted-text mt-1">{m.blurb}</p>
                  {m.upcharge > 0 && (
                    <p
                      className="text-xs brand-text font-semibold mt-2"
                      data-testid={`mesh-line-${m.id}`}
                    >
                      +${lineTotal.toFixed(0)} for {qty} {qty === 1 ? "screen" : "screens"}
                    </p>
                  )}
                  {m.upcharge === 0 && isSelected && (
                    <p className="text-xs muted-text mt-2">No extra charge — included.</p>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <p className="text-[11px] muted-text mt-3 px-1">
        Mesh upgrades are optional. The same mesh applies to all {qty} {qty === 1 ? "screen" : "screens"} in this order.
      </p>

      <div className="flex gap-3 mt-8">
        <button
          data-testid="back-btn"
          type="button"
          onClick={goBack}
          className="flex-1 py-3 rounded-full border-2 border-[var(--brand-border)] font-semibold"
        >
          Back
        </button>
        <button data-testid="continue-btn" className="cta-btn flex-1" onClick={goNext}>
          Continue
        </button>
      </div>
    </div>
  );
}
